module.exports = __webpack_public_path__ + "img/1591341490.9aeb6dfe.jpg";